import React, { useState } from "react";
import { LayoutPage } from "../../components/Layout/layoutPage";
import TopBar from "../../components/TopBar/TopBar";
import { Link, useLocation, useNavigate } from "react-router-dom";
import CloseIcon from "@mui/icons-material/Close";
import { InputCustom } from "../../components/Input/InputCustom";
import { useDispatch, useSelector } from "react-redux";
import { useAuthApi } from "../../api/AuthApi";
import CircularProgress from "@mui/material/CircularProgress";
import { importBaseActions } from "../../store/reducers/base";
import { Button } from "@mui/material";
import { useNavigationStack } from "../../v2/providers/NavigationContext";
import TopBarMinimal from "../../components/TopBar/TopBarMinimal";

export const NewPassword = () => {
    const dispatch = useDispatch();
    const baseActions = importBaseActions();
    const [dialogError, setDialogError] = useState({open: false, title: "", error: ""});
    const [loading, setLoading] = useState(false);
    const baseState = useSelector(state => state.base);
    const navigate = useNavigate();
    const authApi = useAuthApi();
    const [localState, setLocalState] = useState({
        new_password: "",
        confirm_new_password: "",
        errors: {},
        alert: "",
        isBusy: false
    });
    const submit = async (e) => {
        e.preventDefault();
        e.stopPropagation();
        let errors = {
            new_password: !localState.new_password || localState.new_password.length < 3,
            confirm_new_password: !localState.confirm_new_password || localState.new_password != localState.confirm_new_password
        };
        if (errors.new_password || errors.confirm_new_password) {
            setLocalState({...localState, errors});
            return;
        }
        setLocalState({...localState, isBusy: true});
        try {
            let res = await authApi.newPassword(baseState.user.token, baseState.user.id, baseState.user.userType, localState.new_password);
            
            if (res.success != 1) throw res.message;

            let destination = "/configurations";
            
            navigate(destination);
        } catch (e) {
            setLocalState({...localState, isBusy: false, alert: e});
        }
    }

    return (
        <LayoutPage>
            <div style={{ flex: "0 0 auto" }}>
                <TopBarMinimal />
                <div className={"d-flex justify-content-between p-3"}>
                    <div className="d-flex flex-column" style={{ lineHeight: "1" }}>
                        <h2 className="h2 fw-bold">
                            Modifica password
                        </h2>
                    </div>
                </div>
                <div style={{ flex: "1 1 auto", minHeight: "0" }}>
                    <div className="container py-3">
                        <div className="row justify-content-center">
                            <div className="col-xl-6">
                               <InputCustom
                                    sx={{mt: 3}}
                                    name={"new_password"}
                                    label={"Nuova password*"}
                                    type={"password"}
                                    error={""}
                                    placeholder={"Inserisci la tua nuova password..."}
                                    onChange={(e) => setLocalState({...localState, new_password: e.target.value})}
                                    helperText = {localState.errors.new_password ? "La password deve contenere almeno almeno 8 caratteri" : ""}
                                />
                                <InputCustom
                                    sx={{mt: 3}}
                                    name={"confirm_new_password"}
                                    label={"Conferma nuova password*"}
                                    type={"password"}
                                    placeholder={"Conferma la tua nuova password..."}
                                    error={localState.errors.confirm_new_password}
                                    onChange={(e) => setLocalState({...localState, confirm_new_password: e.target.value})}
                                    helperText = {localState.errors.confirm_new_password ? "Le password non coincidono" : ""}
                                />
                                {localState.alert && (
                                        <div className="alert alert-danger">
                                            <span>{localState.alert}</span>
                                        </div>
                                    )}

                                    <div className="text-end mt-3">
                                        {!localState.isBusy ? (
                                            <Button
                                                fullWidth
                                                onClick={submit}    
                                                variant="contained"
                                                sx={{ mt: 2, py: 1.5, fontWeight: "bold", fontSize: 16 }}
                                            >
                                                SALVA PASSWORD
                                            </Button>
                                        ) : (
                                            <div className="d-flex justify-content-center mt-3">
                                                <CircularProgress />
                                            </div>
                                        )}                                
                                    </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </LayoutPage>
    );
}